const getNormalizedAge = (age: string): number => {
  const s = String(age).trim();
  const normalizedAge = s === '' ? NaN : Number(s);
  return normalizedAge;
};

export default getNormalizedAge;
